import axios from 'axios'

const baseURL = process.env.NODE_ENV === 'production' 
  ? (process.env.VUE_APP_API_URL || '') 
  : ''

const instance = axios.create({
  baseURL: baseURL,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  }
})

instance.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 404:
          console.error('Resource not found')
          break
        case 500:
          console.error('Server error')
          break
        default:
          console.error('An error occurred')
      }
    }
    return Promise.reject(error)
  }
)

export default instance
